module.exports = __webpack_public_path__ + "static/media/hardware-banner1.ab7c6d0f.png";